import { memo, useCallback, useEffect, useState } from "react";

import { getFleetVehicleOfferRentAPI, sendFleetVehicleOfferRentEmailAPI } from "services/api/fleet/vehicles/offers/api";
import { transformFleetDocumentUploadToFileExtended } from "services/api/fleet/vehicles/offers/transformations";

import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import { EmailSendModal } from "ui/components/Modal/EmailSendModal";

import { OfferEmailModalProps } from "./types";
import { EmailSendData } from "ui/components/Modal/EmailSendModal/types";
import { FleetVehicleOfferRent } from "services/api/fleet/vehicles/offers/types";


const OfferEmailModal: React.FC<OfferEmailModalProps> = (props) => {
  const { show, onHide, formValues } = props;

  const [pdfAttachment, setPdfAttachment] = useState<FileExtended | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!show) return;
    setPdfAttachment(null);
    fetchPdfAttachment();
  }, [show]);

  const fetchPdfAttachment = async () => {
    setIsLoading(true);
    try {

      const result: FleetVehicleOfferRent = await getFleetVehicleOfferRentAPI(formValues.id!);
      if (result.pdfUpload) {
        setPdfAttachment(transformFleetDocumentUploadToFileExtended(result.pdfUpload));
      }
    } catch {
      // ignore
    }
    setIsLoading(false);
  };

  const handleSend = useCallback(async (data: EmailSendData) => {
    return await sendFleetVehicleOfferRentEmailAPI(formValues.id!, data);
  }, [formValues.id]);

  return (
    <EmailSendModal
      show={show}
      onHide={onHide}
      title={`Slanje putem e-maila [Ponuda ${formValues.offerNumber ?? ""}]`}
      initialFormValues={{
        subject: `Ponuda ${formValues.offerNumber ?? ""}`,
        content: `Poštovani,\n\nu privitku e-maila šaljemo Ponudu za plaćanje.\n\nLijep pozdrav`,
        pdfAttachment: pdfAttachment,
      }}
      contactId={formValues.contactClientId ?? undefined}
      onSend={handleSend}
      isLoading={isLoading}
    />
  );
};

export default memo(OfferEmailModal);
